/** @jsx jsx */
import { Box, Card, Heading, jsx } from 'theme-ui'

import Img from 'gatsby-image'
import Body from '../shared/Typography/Body/Body'
import { Product, ProductCardImage } from './ProductCard'
import Paragraph from '../shared/Typography/Paragraph/Paragraph'
import { BgImg } from '../shared/BgImage'
import Link from '../shared/Typography/Link/Link'
import Button from '../shared/Buttons/Button'
import { navigate } from 'gatsby'

const InfoCard = ({ shopifyId, ...props }) => {
  const to = props.actionButton.toSlug
  return (
    <Card
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        position: 'relative',
        gridColumn: 'span 2',
        alignItems: 'flex-end',
        textAlign: 'left',
        minHeight: ['325px', '400px', null, 'auto'],
        cursor: 'pointer',
      }}
      onClick={() => {
        navigate(to.startsWith('/') ? to : `/${to}`)
      }}
    >
      {props.image && (
        <BgImg
          backgroundColor={'#eeeeee'}
          objectFit="cover"
          fluid={props.image.fluid}
        />
      )}
      <Box
        sx={{
          position: 'relative',
          zIndex: 10,
          p: 25,
          pt: 0,
          width: '100%',
          background:
            'linear-gradient(0deg, rgba(0,0,0,0.5046393557422969) 0%, rgba(0,0,0,0.4738270308123249) 50%, rgba(0,0,0,0) 100%)',
        }}
      >
        <Heading
          as="h4"
          sx={{
            color: 'white',
          }}
          variant="semiBold"
        >
          {props.title}
        </Heading>
        {props.description && (
          <Body
            variant="body1semibold"
            sx={{
              color: 'white',
              lineHeight: 'normal',
            }}
          >
            {props.description.description}
          </Body>
        )}
        {props.actionButton && (
          <Button
            to={props.actionButton.toSlug}
            sx={{
              mt: props.actionButton.buttonStyle === 'whiteLink' ? '5px' : 15,
              p:
                props.actionButton.buttonStyle === 'whiteLink'
                  ? '0px'
                  : '8px 16px',
            }}
            variant={props.actionButton.buttonStyle || 'whiteLink'}
            size={props.actionButton.buttonSize || 'medium'}
          >
            {props.actionButton.buttonLabel}
          </Button>
        )}
      </Box>
    </Card>
  )
}

export default InfoCard
